<app-king-user-avatar [kingUser]="user()" [isChallenger]="isChallenger()" />
<div class="hp-side">
  <div class="hp-side__player">
    {{ user() ? user()!.name : isChallenger() ? "CHALLENGER" : "KING" }}
    <svg-icon
      class="flex items-center justify-center s-24"
      [src]="
        isChallenger()
          ? 'assets/icons/king/sword.svg'
          : 'assets/icons/games/king.svg'
      "
      [class.color]="isChallenger() ? '#356BB9' : '#E15050'"
    ></svg-icon>
  </div>
  @if (user()) {
  <app-king-hp-bar
    [user]="user()!"
    [isChallenger]="isChallenger()"
  ></app-king-hp-bar>
  } @else {
  <div class="hp-side__create" style="height: 44px">
    <button
      class="hp-side__create--button button button--style-yellow padding-x-12 h-36"
      (click)="openDepositModal()"
    >
      @if (!isChallenger()) {
      <app-game-icon icon [game]="'King'" color="black"> </app-game-icon>
      } @else {
      <svg-icon
        class="flex items-center justify-center s-24"
        src="assets/icons/king/sword.svg"
      ></svg-icon>
      }
      <span>Join Game</span>
    </button>
  </div>
  }
</div>
<div class="weapon-side">
  @if (user() && attackAnimation()) {
  <app-king-weapon
    @fadeInAnimation
    class="weapon-side__animation"
    [weapon]="attackAnimation()!"
    [reverse]="isChallenger()"
  ></app-king-weapon>
  }
</div>
